<template>
  <div>
    <v-btn color="purple" @click="backToTownships" text>
      <v-icon left> mdi-arrow-left-thin-circle-outline </v-icon>
      go Back
    </v-btn>
    <v-row justify="center">
      <v-col cols="12" md="11" lg="10" xl="8">
        <v-card class="card--shadow">
          <v-card-title class="presumptive-top-actions pa-2 pa-sm-3">
            <div
              class="d-flex flex-wrap align-stretch align-sm-center justify-start"
            >
              <v-btn
                @click="viewPresumptiveReferral"
                class="presumptive-top-btn ma-1"
                outlined
                color="teal accent-4"
                dark
              >
                <v-icon left dark>mdi-format-list-bulleted</v-icon>
                <span class="presumptive-btn-label"
                  >Referred and Examined (Volunteer)</span
                >
              </v-btn>
              <v-btn
                @click="viewPresumptiveList"
                class="presumptive-top-btn ma-1"
                outlined
                color="teal accent-4"
                dark
              >
                <v-icon left dark>mdi-format-list-bulleted</v-icon>
                <span class="presumptive-btn-label"
                  >Examined (Referred by Vol+FO+Self)</span
                >
              </v-btn>
              <v-btn
                @click="viewSupportingTownshipPresumptiveList"
                class="presumptive-top-btn ma-1"
                outlined
                color="teal accent-4"
                dark
              >
                <v-icon left dark>mdi-format-list-bulleted</v-icon>
                <span class="presumptive-btn-label">Presumptive Township</span>
              </v-btn>
              <v-btn
                @click="viewCreatePst"
                class="presumptive-top-btn ma-1"
                outlined
                color="teal accent-4"
                dark
              >
                <v-icon left dark>mdi-plus-circle-outline</v-icon>new
              </v-btn>
            </div>
          </v-card-title>
          <v-card-title class="text-subtitle-1 text-wrap pa-3 pb-0">
            Contact Tracing
          </v-card-title>
          <v-card-text class="pt-2">
            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <label>Index Case Code</label>
                <v-text-field
                  v-model.trim="indexCode"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label>Index Case Year</label>
                <v-text-field
                  v-model.trim="indexYear"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label>Mono-Poly</label>
                <v-select
                  v-model="monopoly"
                  :items="initialMonopoly"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-card
                  outlined
                  class="outside-township-card pa-3"
                  elevation="0"
                >
                  <div
                    class="d-flex flex-column flex-sm-row flex-sm-wrap align-sm-center"
                  >
                    <div class="outside-township-label mr-sm-3 mb-2 mb-sm-0">
                      <v-icon small class="mr-1">mdi-map-marker-outline</v-icon>
                      Outside Township
                    </div>
                    <v-radio-group
                      v-model="outside_township"
                      class="outside-township-radio mt-0 flex-grow-0"
                      hide-details
                      dense
                      row
                    >
                      <v-radio label="No" value="1" color="teal accent-4"></v-radio>
                      <v-radio label="Yes" value="2" color="teal accent-4"></v-radio>
                    </v-radio-group>
                    <v-expand-transition>
                      <div
                        v-if="outside_township == 2"
                        class="outside-township-select-wrap mt-2 mt-sm-0 ml-sm-4 flex-grow-1"
                        style="min-width: 0"
                      >
                        <v-select
                          :items="outside_townships"
                          v-model="outside_township_id"
                          item-text="name"
                          item-value="id"
                          label="Select township"
                          dense
                          outlined
                          clearable
                          placeholder="Choose township"
                        >
                          <template v-slot:label>
                            <span>
                              Select township
                              <require-sign v-if="outside_township == 2" />
                            </span>
                          </template>
                        </v-select>
                      </div>
                    </v-expand-transition>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" class="text-center text-sm-right pt-1">
                <v-btn
                  class="presumptive-search-btn"
                  height="40"
                  color="purple accent-4"
                  @click.prevent="searchPspByIndexCode"
                  outlined
                  rounded
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>Search
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              v-if="showList && !loading && indexCode && indexYear"
              class="mt-2"
              dense
            >
              <v-col cols="12" sm="auto" class="pb-sm-0">
                <v-btn
                  @click="addCloseContact"
                  class="presumptive-action-btn mb-2 mr-sm-2"
                  outlined
                  color="teal accent-4"
                  dark
                >
                  <v-icon left dark>mdi-plus-circle-outline</v-icon>Add Close Contact
                </v-btn>
              </v-col>
              <v-col cols="12" sm="auto" class="pb-sm-0">
                <v-btn
                  @click="addOtherContact"
                  class="presumptive-action-btn mb-2 mr-sm-2"
                  outlined
                  color="teal accent-4"
                  dark
                >
                  <v-icon left dark>mdi-plus-circle-outline</v-icon>Add Other Contact
                </v-btn>
              </v-col>
              <v-col cols="12" sm="auto">
                <v-btn
                  @click="addFamilyMember"
                  class="presumptive-action-btn mb-2"
                  outlined
                  color="teal accent-4"
                  dark
                >
                  <v-icon left dark>mdi-plus-circle-outline</v-icon>Add Family Member
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-title class="text-subtitle-1 text-wrap pa-3 pb-0">
            Follow up
          </v-card-title>
          <v-card-text class="pt-2">
            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <label>Code</label>
                <v-text-field
                  v-model.trim="followCode"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label>Year</label>
                <v-text-field
                  v-model.trim="followYear"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label>Mono/Poly</label>
                <v-select
                  v-model="followmonopoly"
                  :items="initialMonopoly"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <!-- <v-col cols="12">
                <v-card
                  outlined
                  class="outside-township-card pa-3"
                  elevation="0"
                >
                  <div
                    class="d-flex flex-column flex-sm-row flex-sm-wrap align-sm-center"
                  >
                    <div class="outside-township-label mr-sm-3 mb-2 mb-sm-0">
                      <v-icon small class="mr-1">mdi-map-marker-outline</v-icon>
                      Outside Township
                    </div>
                    <v-radio-group
                      v-model="followOutsideTownship"
                      class="outside-township-radio mt-0 flex-grow-0"
                      hide-details
                      dense
                      row
                    >
                      <v-radio label="No" value="1" color="teal accent-4"></v-radio>
                      <v-radio label="Yes" value="2" color="teal accent-4"></v-radio>
                    </v-radio-group>
                    <v-expand-transition>
                      <div
                        v-if="followOutsideTownship == 2"
                        class="outside-township-select-wrap mt-2 mt-sm-0 ml-sm-4 flex-grow-1"
                        style="min-width: 0"
                      >
                        <v-select
                          :items="outside_townships"
                          v-model="followOutsideTownshipId"
                          item-text="name"
                          item-value="id"
                          label="Select township"
                          dense
                          outlined
                          clearable
                          placeholder="Choose township"
                        >
                          <template v-slot:label>
                            <span>
                              Select township
                              <require-sign v-if="followOutsideTownship == 2" />
                            </span>
                          </template>
                        </v-select>
                      </div>
                    </v-expand-transition>
                  </div>
                </v-card>
              </v-col> -->
              <v-col cols="12" class="text-center text-sm-right pt-1">
                <v-btn
                  class="presumptive-search-btn"
                  height="40"
                  color="purple accent-4"
                  @click.prevent="searchPspByPreviousCode"
                  outlined
                  rounded
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>Search
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              v-if="showList && !loading && followCode && followYear"
              class="mt-2"
              dense
            >
              <v-col cols="12" sm="auto">
                <v-btn
                  @click="addFollowUp"
                  class="presumptive-action-btn"
                  outlined
                  color="teal accent-4"
                  dark
                >
                  <v-icon left dark>mdi-plus-circle-outline</v-icon>Add Follow Up
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <div v-if="showList && !loading" class="mt-5">
          <section v-if="presumptiveData.length == 0 && patient">
           <v-card
             elevation="0"
             color="pink accent-1"
             class="pa-2 d-flex justify-center bg-pink"
           >
           <p class="noti-text white--text">
               <v-icon class="white--text mr-1"
                 >mdi-clipboard-alert-outline</v-icon
               >Sorry, patient exists but no family members!
             </p>
           </v-card>
         </section>

         <section v-if="!patient && presumptiveData.length == 0">
        
           <v-card
             elevation="0"
             color="pink accent-1"
             class="pa-2 d-flex justify-center bg-pink"
           >
           <p class="noti-text white--text">
               <v-icon class="white--text mr-1"
                 >mdi-clipboard-alert-outline</v-icon
               >Sorry, patient does not exist!
             </p>
           </v-card>
         </section>

          <!-- <section v-if="presumptiveData==null || presumptiveData.length == 0 ">
            <v-card
              elevation="0"
              color="pink accent-1"
              class="pa-2 d-flex justify-center bg-pink"
            >
              <p class="noti-text white--text">
                <v-icon class="white--text mr-1"
                  >mdi-clipboard-alert-outline</v-icon
                >Sorry, no match patients!
              </p>
            </v-card>
          </section> -->
          <div v-else>
           <search-list v-if="showList && !loading && presumptiveData.length>0 " :updatedPresumptiveData="updatedPresumptiveData" />
         </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { required } from "vuelidate/lib/validators";
import SearchList from "@/components/presumptive/SearchList.vue";
import RequireSign from "@/components/notification/RequireSign.vue";
import { mapState, mapActions } from "vuex";

export default {
  mixins: [ValidationMixin],
  components: {
    SearchList,
    RequireSign,
  },
  data: () => ({
    showList: false,
    initialMonopoly: ["No", "Yes", "SG", "MGY", "TGI"],
    initial: null,
    indexYear: null,
    indexCode: null,
    monopoly: null,
    followmonopoly: null,
    previousID: null,
    outside_township: "1",
    outside_township_id: null,
    followOutsideTownship: "1",
    followOutsideTownshipId: null,
  }),
  validations: {
    IndexYear: {
      required,
    },
    indexCode: {
      required,
    },
  },
  watch: {
    outside_township(val) {
      if (val === "2") {
        const tid = this.$route.params.township_id;
        if (tid) this.getOutsideTownships(tid);
      } else {
        this.outside_township_id = null;
      }
    },
    followOutsideTownship(val) {
      if (val === "2") {
        const tid = this.$route.params.township_id;
        if (tid) this.getOutsideTownships(tid);
      } else {
        this.followOutsideTownshipId = null;
      }
    },
  },
  methods: {
    ...mapActions("Township", ["getOutsideTownships"]),
    backToTownships() {
      this.$router.push({
        name: "pre-townships",
      });
    },
    searchPspByIndexCode() {
      if (this.indexYear && this.indexCode) {
        if (
          this.outside_township === "2" &&
          (this.outside_township_id == null || this.outside_township_id === "")
        ) {
          this.$toast.error("Please select outside township");
          return;
        }
        this.followCode = "";
        this.followYear = "";
        let data = {
          index_case_no: this.indexCode,
          index_case_year: this.indexYear,
          index_case_monopoly:
            this.monopoly === "Yes"
              ? 2
              : this.monopoly === "SG"
                ? 3
                : this.monopoly === "MGY"
                  ? 4
                  : this.monopoly === "TGI"
                    ? 5
                    : 1,
          township_id: this.$route.params.township_id,
          outside_township: this.outside_township,
          ...(this.outside_township === "2" &&
            this.outside_township_id != null && {
              outside_township_id: this.outside_township_id,
            }),
          // index_case_initial: this.initial ? this.initial : "",
          case_found_at: 3,
        };

        this.showList = false;
        this.$store.dispatch("Patient/getByIndexCode", data).then(() => {
          this.$store
            .dispatch("Presumptive/searchByIndexCode", data)
            .then(() => {
              this.showList = true;
            });
        });
      }
    },
    searchPspByPreviousCode() {
      if (this.followCode && this.followYear) {
        if (
          this.followOutsideTownship === "2" &&
          (this.followOutsideTownshipId == null ||
            this.followOutsideTownshipId === "")
        ) {
          this.$toast.error("Please select outside township");
          return;
        }
        this.indexCode = "";
        this.indexYear = "";
        let data = {
          index_case_no: this.followCode,
          index_case_year: this.followYear,
          index_case_monopoly:
            this.followmonopoly === "Yes"
              ? 2
              : this.followmonopoly === "SG"
                ? 3
                : this.followmonopoly === "MGY"
                  ? 4
                  : this.followmonopoly === "TGI"
                    ? 5
                    : 1,
          index_case_initial: "",
          // index_case_initial: this.followInitial ? this.followInitial : "",
          township_id: this.$route.params.township_id,
          outside_township: this.followOutsideTownship,
          ...(this.followOutsideTownship === "2" &&
            this.followOutsideTownshipId != null && {
              outside_township_id: this.followOutsideTownshipId,
            }),
          case_found_at: 5,
        };
        this.showList = false;
         
        this.$store
            .dispatch("Presumptive/searchByIndexCode", data)
            .then(() => {
              this.showList = true;
            });
            
            // searchByPreviousCode
        //   this.$store.dispatch("Presumptive/storeCi", data).then(() => {
        //   this.showList = true;
        // });
      }
    },
    viewCreatePst() {
      this.$router.push({
        name: "create-presumptive",
        params: {
          township_id: this.$route.params.township_id,
          type: JSON.stringify({ type: "New" }),
        },
      });
    },
    viewPresumptiveList() {
      this.$router.push({
        name: "presumptive-list",
        params: { township_id: this.$route.params.township_id },
      });
    },
    viewSupportingTownshipPresumptiveList() {
      this.$router.push({
        name: "presumptive-list",
        query: {supportingTownship: true},
        params: { township_id: this.$route.params.township_id },
      });
    },
    viewPresumptiveReferral() {
      this.$router.push({
        name: "presumptive-referral",
        params: { township_id: this.$route.params.township_id },
      });
    },
    addCloseContact() {
      this.$router.push({
        name: "create-presumptive",
        params: {
          township_id: this.$route.params.township_id,
          type: JSON.stringify({
            type: "close-contact",
            index_case_no: this.indexCode,
            index_case_year: this.indexYear,
            index_case_monopoly: this.monopoly,
          }),
        },
      });
    },
    addOtherContact() {
      this.$router.push({
        name: "create-presumptive",
        params: {
          township_id: this.$route.params.township_id,
          type: JSON.stringify({
            type: "other-contact",
            index_case_no: this.indexCode,
            index_case_year: this.indexYear,
            index_case_monopoly: this.monopoly,
          }),
        },
      });
    },
    addFollowUp() {
      this.$router.push({
        name: "create-presumptive",
        params: {
          township_id: this.$route.params.township_id,
          type: JSON.stringify({
            type: "Follow-up",
            index_case_no: this.followCode,
            index_case_year: this.followYear,
          }),
        },
      });
    },
    addFamilyMember() {
     
      if (this.patient) {
        this.$router.push({
          name: "PatientFamily",
          params: {
            patient_id: this.patient.id,
          },
        });
      } else {
         this.$toast.error("Patient not found");
      //  alert("Patient not found");
      }
    },
  },

  computed: {
    ...mapState("Presumptive", ["presumptiveData"]),
    ...mapState("Patient", ["patient"]),
    ...mapState("Loading", ["loading"]),
    ...mapState("Township", ["outside_townships"]),
  },
  created() {
    this.$store.dispatch("Presumptive/clearData");
  },
};
</script>

<style scoped>
.noti-text {
  color: #ffffff;
  font-size: 18px;
  margin-top: 10px;
  margin-right: 10px;
  letter-spacing: 1px;
}
.theme--light.v-data-table {
  margin-bottom: 100px !important;
}
.outside-township-card {
  border-radius: 8px;
  border-color: rgba(0, 0, 0, 0.12);
  background-color: rgba(0, 150, 136, 0.04);
}

.outside-township-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
}

.presumptive-search-btn {
  width: 100%;
  max-width: 22rem;
}

@media (min-width: 600px) {
  .presumptive-search-btn {
    width: auto;
    max-width: none;
  }
}

.presumptive-top-actions {
  display: block;
  width: 100%;
}

.presumptive-top-btn {
  width: 100%;
  height: auto !important;
  min-height: 40px;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.presumptive-top-btn >>> .v-btn__content {
  justify-content: flex-start;
  white-space: normal;
  text-align: left;
}

@media (min-width: 600px) {
  .presumptive-top-btn {
    width: auto;
    max-width: 100%;
    height: auto !important;
    min-height: 40px;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
}

.presumptive-btn-label {
  text-align: left;
  white-space: normal;
  line-height: 1.25;
}

.presumptive-action-btn {
  width: 100%;
}

@media (min-width: 600px) {
  .presumptive-action-btn {
    width: auto;
  }
}
</style>
